<div class="page-body">
  <div *ngIf="isError || isLandingError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">{{ errorHeading }}</h3>
      <p class="info-text">{{ errorInfo }}</p>
    </div>
  </div>

  <div *ngIf="!isError && !isLandingError">
    <app-spinner></app-spinner>
  </div>
</div>
